import {Layout, ListItem, SelectValue} from '@phonectas/unifon-ui-kit';
import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {StyledSelectRequired} from './styled';

interface ClientIdSelectorProps {
    clientIds?: number[];
    onChange: (value: number) => void;
	required?: boolean;
}

const ClientIdSelector: React.FC<ClientIdSelectorProps> = ({clientIds, onChange, required}) => {
	const [t] = useTranslation();
	const [selectedGroup, setSelectedGroup] = useState<number | null>(null);

	const handleGroupChange = useCallback((val: SelectValue, _e: React.SyntheticEvent, _name: string) => {
		let value;
		if (typeof val === 'number') {
			value = val ?? null;
		} else if (Array.isArray(val)) {
			value = val[0] !== undefined ? Number(val[0]) : null;
		}

		if (!value) return;

		setSelectedGroup(value);
		onChange(value);
	}, [onChange]);

	return (
		<Layout>
			<StyledSelectRequired
				label={t('Client ID')}
				name='client_id'
				onChange={handleGroupChange}
				value={selectedGroup}
				compact
				required={required || false}
			>
				{(clientIds ?? []).map((id) => (
					<ListItem
						key={id}
						value={id}
						selected={selectedGroup === id}
						primaryText={String(id)}
					/>
				))}
			</StyledSelectRequired>
		</Layout>
	);
};

export default ClientIdSelector;